import React, { useEffect, useRef, useState } from "react";
import styles from "./EditContact.module.css";
import TextInput from "../../Components/TextInput/TextInput";

import { FaUser } from "react-icons/fa";
import { aphabetValidator, phoneValidate } from "../../Values/validatorsnew";
import { connect, useDispatch } from "react-redux";
import {
  contactResources,
  editContact,
  editLead,
  fetchConstants,
  fetchpropertySubType,
  contactResourcesMongo
} from "../../Services/contacts";
import Loading from "../../Components/Loading/Loading";
import { AiOutlineClose } from "react-icons/ai";
import Select from "react-select";
import Dropdown from "../../Components/DropDown/Dropdown";
import { useLocation } from "react-router";
import { showSnackbarAction } from "../../Redux/actions";
import { addContactFilterValue, country_code, url} from "../../Values/constants";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import { getDateAndTime, getFormattedDate } from "../../Values/utils";
import moment from "moment";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics, googleAnalyticsCTAClick } from "../../Services/users";
import { getLocationData } from "../../Services/resources";
import DropDownWithDisplayName from "../../Components/DropDown/DropDownWithDisplayName";

const EditContact = ({
  history,
  userRole,
  theme,
  user,
  authToken,
  organizationData,
  constants,
  organizationResources,
  mbConstants
}: {
  history: any;
  userRole: any;
  theme: any;
  user: any;
  authToken:any;
  organizationData:any;
  constants:any,
  organizationResources:any;
  mbConstants:any;
}) => {

  const Requirement=[
    "NEW PROJECT",
    "RENTAL",
    "RESALE"
  ];
  const location: any = useLocation();
  const dispatcher = useDispatch();
  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const numberRef: any = useRef();
  const unitRef: any = useRef();
  const cityRef: any = useRef();
  const dateRef: any = useRef(null);
  const ansdateRef: any = useRef(null);
  const alternateNumberRef: any = useRef();

  const otherNotIntRef: any = useRef();

  const otherLostRef: any = useRef();
  const leadSourceRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [locationsList, setLocationsList] = useState<any[]>([]);
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [projectsList, setProjectsList] = useState<any[]>([]);
  const [notIntReasonList, setNotIntReasonList] = useState<any[]>([]);
  const [lostReasonList, setLostReasonList] = useState<any[]>([]);
  const [propertyTypeList, setPropertyTypeList] = useState<any[]>([]);
  const [propertyStageList, setPropertyStageList] = useState<any[]>([]);
  const [addSet, setAddSet] = useState<any[]>([]);
  const [constantBudget, setConstantBudget] = useState<any[]>(mbConstants?.buyBudget?mbConstants?.buyBudget:[]);
  const [requirement_Type, setRequirement_Type] = useState<any>({
    label: location.state.detail.requirement_Type
    ? location.state.detail.requirement_Type
    :"Select",
    value: location.state.detail.requirement_Type
    ? location.state.detail.requirement_Type
    :"Select",
  });
  const [cusAdd, setCusAdd] = useState<any>(
    location.state.detail.address
      ? location.state.detail.address
      : "",
  );
  const [gender, setGender] = useState<any>(
    {
      label: location.state.detail.gender
      ? location.state.detail.gender
      : "Select",
    value: location.state.detail.gender
      ? location.state.detail.gender
      : "Select",
    }
  );
  const [marital, setMarital] = useState<any>(
    {
      label: location.state.detail.marital_status
      ? location.state.detail.marital_status
      : "Select",
    value: location.state.detail.marital_status
      ? location.state.detail.marital_status
      : "Select",
    }
  );
  const [addSetSelected, setAddSetSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [stageSelected, setStageSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [campaignSetSelected, setCampaignSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [propertyTypeSelected, setPropertyTypeSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [propertyStageSelected, setPropertyStageSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [locationSelected, setlocationSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [budgetSelected, setBudgetSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [projectSelected, setProjectSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [businessVerticalSelected, setBusinessVerticalSelected] =
  useState<any>({
    label: "Select",
    value: "Select",
  });
  const [leadTypeList, setleadTypeList] =
    useState<any[]>([]);
  // const [notIntSelected, setNotIntSelected] = useState<any>({
  //   label: "Select",
  //   value: "Select",
  // });
  // const [lostSelected, setLostSelected] = useState<any>({
  //   label: "Select",
  //   value: "Select",
  // });
  const [leadSourceSelected, setLeadSourceSelected] = useState<any>({
    label: location.state.detail.lead_source
      ? location.state.detail.lead_source
      : "Select",
    value: location.state.detail.lead_source
      ? location.state.detail.lead_source
      : "Select",
  });
  const [propertySubTypeSelected, setPropertySubTypeSelected] = useState<any>({
    label: location.state.detail.property_sub_type
      ? location.state.detail.property_sub_type
      : "Select",
    value: location.state.detail.property_sub_type
      ? location.state.detail.property_sub_type
      : "Select",
  });
  const [leadTypeSelected, setLeadTypeSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });
  const [leadSourceList, setLeadSourceList] = useState<any[]>([]);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<any[]>([]);
  const [countryCode, setCountryCode] = useState<string>("");
  const [countryCodeList, setCountryCodeList] = useState<string[]>([]);
  const [campaign, setCampaign] = useState<any[]>([]);
  const [businessVerticalList, setBusinessVerticalList] = useState<any[]>(
    []
  );
  const stage = [
    "FRESH",
    "WON",
    "CALL BACK",
    "INTERESTED",
    "LOST",
    "NOT-INTERESTED",
  ];
  const [stateList, setStateList] = useState<any[]>([]);
  const [stateSelected, setStateSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });

  useEffect(() => {
    if (ansdateRef?.current) {
      ansdateRef.current.value = location?.state?.detail?.anniversary_date
        ? location.state.detail.anniversary_date.split("T")[0]
        : "";
    }
    if (dateRef?.current) {
      dateRef.current.value = location?.state?.detail?.dob
        ? location.state.detail.dob.split("T")[0]
        : "";
    }
  }, [location?.state?.detail]);


  const [industrialTypes, setIndustrialTypes] = useState<any[]>([]);
  const [institutionalTypes, setInstitutionalTypes] = useState<any[]>([]);
  const [isGACalled, setIsGACalled] = useState<any>(false);

  // const propertyStageList:any=[];
  // Object.keys(propertyStage).forEach((key)=>{
  //   propertyStageList.push(propertyStage[key])
  // })

  const constant = async () => {
    const propertyStageValues = Object.values(constants.propertyStage);
    const propertyTypeValues = Object.values(constants.propertyType);
    setPropertyStageList(propertyStageValues);
    setPropertyTypeList(propertyTypeValues);
    const notIntReasonValues = Object.values(constants.notInterestedReason);
    const lostReasonValues = Object.values(constants.lostReasons);
    setNotIntReasonList(notIntReasonValues);
    setLostReasonList(lostReasonValues);
  };
  useEffect(() => {
    if (constants) {
      constant();
    }
  }, [constants]);

  
  useEffect(() => {
    if(authToken){
      getLeadsFilterValues();
    }
  }, [user.uid,authToken]);

  const getLeadsFilterValues = async () => {
    // axios.defaults.headers.common['x-access-token'] =
    //   authToken
    const res = await axiosHandler.post(url + '/leads/filterValues', {
      // uid: user.uid,
      showColumns:addContactFilterValue                                                                           
    });
    setAddSet(res.data[0]?.addset);
    setCampaign(res.data[0]?.campaign);
  }

  useEffect(() => {
    let data: any[] = [];
    country_code.forEach((item) => {
      data.push(item.dial_code + " " + item.name);
    });
    setCountryCodeList(data);
    if (location.state.detail.country_code) {
      setCountryCode(location.state.detail.country_code);
    }
  }, []);

  const choice = () => {
    let data = countryCodeList.map((item: any) => ({
      value: item,
      label: item,
    }));
    return data;
  };
// console.log("location.state.detail",location.state.detail)
useEffect(()=>{
   if(organizationResources){
    organizationResources.forEach((val:any)=>{
      if(val.resource_type==="locations"){
        let loc:any=[]
        val["locations"].forEach((item:any)=>{
              loc.push(item.location)
        })
        setLocationsList(loc)
      }
      if(val.resource_type==="budgets"){
        let loc:any=[]
        val["budgets"].forEach((item:any)=>{
              loc.push(item.budget)
        })
        setBudgetsList(loc);
      }
  
      if(val.resource_type==="businessVertical"){
        let loc:any=[]
        val["businessVertical"].forEach((item:any)=>{
              loc.push(item.businessVertical)
        })
        setBusinessVerticalList(loc);
      }
      if(val.resource_type==="leadSources"){
        let loc:any=[]
        val["leadSources"].forEach((item:any)=>{
              loc.push(item.leadSource)
        })
        setLeadSourceList(loc);
      }
  
      if(val.resource_type==="comTypes"){
        let loc:any=[]
        val["comTypes"].forEach((item:any)=>{
              loc.push(item.comType)
        })
        setComTypes(loc);
      }
      if(val.resource_type==="resTypes"){
        let loc:any=[]
        val["resTypes"].forEach((item:any)=>{
              loc.push(item.resType)
        })
        setResTypes(loc);
      }
      if(val.resource_type==="industrialTypes"){
        let loc:any=[]
        val["industrialTypes"].forEach((item:any)=>{
              loc.push(item.industrialType)
        })
        setIndustrialTypes(loc);
      }
      if(val.resource_type==="institutionalTypes"){
        let loc:any=[]
        val["institutionalTypes"].forEach((item:any)=>{
              loc.push(item.institutionalType)
        })
        setInstitutionalTypes(loc);
      }
  
      if(val.resource_type==="states"){
        let loc:any=[]
        val["states"].forEach((item:any)=>{
              loc.push(item.state)
        })
        setStateList(loc);
      }
      
    })
   }
},[organizationResources])
  useEffect(() => {
    // const unsub = contactResources(
    //   location.state.detail.organization_id,
    //   (data) => setLocationsList(data),
    //   (data) => setBudgetsList(data),
    //   (data) => setLeadSourceList(data),
    //   (data) => setBusinessVerticalList(data),
    //   organizationData,
    //   () => {},
    //   (data) => setStateList(data),
    // );
    // const unsubConst = fetchConstants(
    //   (data) => setNotIntReasonList(data),
    //   (data) => setLostReasonList(data),
    //   // (data) => setPropertyStageList(data),
    //   // (data) => setPropertyTypeList(data)
    // );
    let data = ["Data", "Leads"];
    setleadTypeList(data);
    // const unsubProperty = fetchpropertySubType(
    //   location.state.detail.organization_id,
    //   (data) => setComTypes(data),
    //   (data) => setResTypes(data),
    //   (data) => setLeadSourceList(data),
    //   (data) => setIndustrialTypes(data),
    //   (data) => setInstitutionalTypes(data)
    // );

    // return () => {
    //   // unsub();
    //   unsubConst();
    //   // unsubProperty();
    // };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    contactResourcesMongo(
      user.organization_id,
      (data) => setProjectsList(data),
      () => {},
      organizationData,
    )
    // eslint-disable-next-line
  }, [user.organization_id]);

  useEffect(() => {
    if (requirement_Type.value === "RENTAL") {
      setConstantBudget(mbConstants?.rentBudget)
    }
    else {
      setConstantBudget(mbConstants?.buyBudget)
    }
  }, [requirement_Type]);

  useEffect(() => {
    if (propertyTypeSelected.value === "Commercial") {
      if(comTypes.length === 0){
        setPropertySubType(mbConstants?.commercial);
      }
      else{
        setPropertySubType(comTypes);
      }
    } else if (propertyTypeSelected.value === "Residential") {
      if(resTypes.length === 0){
        setPropertySubType(mbConstants?.residential);
      }
      else{
        setPropertySubType(resTypes);
      }
    } 
    else if (
      propertyTypeSelected.value === "Industrial"
    ) {
      setPropertySubType(industrialTypes);
    } 
     else if (
      propertyTypeSelected.value === "Institutional"
    ) {
      setPropertySubType(institutionalTypes);
    } 
    else {
      setPropertySubType([]);
    }
  }, [propertyTypeSelected]);
  useEffect(() => {
    setlocationSelected({
      label: location.state.detail.location,
      value: location.state.detail.location,
    });
    setBudgetSelected({
      label: location.state.detail.display_budget?location.state.detail.display_budget:location.state.detail.budget,
      value: location.state.detail.budget,
    });
    setProjectSelected({
      label: location.state.detail.project,
      value: location.state.detail.project,
    });
    setLeadTypeSelected({
      label: location.state.detail.lead_type,
      value: location.state.detail.lead_type,
    });
    // setNotIntSelected({
    //   label: location.state.detail.not_int_reason,
    //   value: location.state.detail.not_int_reason,
    // });
    // setLostSelected({
    //   label: location.state.detail.lost_reason,
    //   value: location.state.detail.lost_reason,
    // });
    setPropertyStageSelected({
      label: location.state.detail.property_stage,
      value: location.state.detail.property_stage,
    });
    setPropertyTypeSelected({
      label: location.state.detail.property_type,
      value: location.state.detail.property_type,
    });
    setCampaignSelected({
      label: location.state.detail.campaign,
      value: location.state.detail.campaign,
    });
    setAddSetSelected({
      label: location.state.detail.addset,
      value: location.state.detail.addset,
    });
    setGender({
      label: location.state.detail.gender,
      value: location.state.detail.gender,
    });
    setMarital({
      label: location.state.detail.marital_status,
      value: location.state.detail.marital_status,
    });
    setBusinessVerticalSelected({
      label: location.state.detail.business_vertical,
      value: location.state.detail.business_vertical,
    });
    setStateSelected({
      label: location.state.detail.state,
      value: location.state.detail.state,
    });
    // eslint-disable-next-line
  }, [
    locationsList,
    budgetsList,
    notIntReasonList,
    projectsList,
    lostReasonList,
    propertyTypeList,
    propertyStageList,
    leadTypeList,
    addSet,
    campaign,
    stateList
    // gender,
    // marital,
  ]);

    const [apiLocationData, setApiLocationData] = useState<any>([]);
    const [DropDownClicked, setDropDownClicked] = useState<any>([]);
    const [searchString, setSearchString] = useState<string>('');
  
  useEffect(()=>{
    const apiFunc = async()=>{
      const apiLocationData = await getLocationData(searchString,DropDownClicked)
      setApiLocationData(apiLocationData)
    }
    if((locationsList?.length===0 || projectsList?.length===0 ) && searchString !=""){
      setApiLocationData([])
      apiFunc()
    }
  },[locationsList,searchString,projectsList])
  const handleCheck = () => {
    if (firstNameRef.current.value === "") {
      firstNameRef.current.value =
        location.state.detail.customer_name.split(" ")[0];
    }
    if (lastNameRef.current.value === "") {
      lastNameRef.current.value =
        location.state.detail.customer_name.split(" ")[1];
    }
    if (numberRef.current.value === "") {
      numberRef.current.value = location.state.detail.contact_no;
    }
    if (numberRef.current.value.length !== 10 && countryCode.split(" ")[0]==="+91") {
      dispatcher(
        showSnackbarAction(
          "Please enter valid number",
          "error"
        )
      );
      return;
    }
    if (alternateNumberRef.current.value === "") {
      alternateNumberRef.current.value = location.state.detail.alternate_no;
    }
    if (stageSelected.label === "Select") {
      stageSelected.label = location.state.detail.stage;
    }
    if (propertyTypeSelected.label === "Select") {
      propertyTypeSelected.label = location.state.detail.property_type;
    }
    if (propertyStageSelected.label === "Select") {
      propertyStageSelected.label = location.state.detail.property_stage;
    }

    if (locationSelected.label === "Select") {
      locationSelected.label = location.state.detail.location;
    }
    if (budgetSelected.label === "Select") {
      budgetSelected.label = location.state.detail.budget;
    }
    if (projectSelected.label === "Select") {
      projectSelected.label = location.state.detail.project;
    }
    if (campaignSetSelected.label === "Select") {
      campaignSetSelected.label = location.state.detail.campaign;
    }
    if (addSetSelected.label === "Select") {
      addSetSelected.label = location.state.detail.addset;
    }
    if (gender.label === "Select") {
      gender.label = location.state.detail.gender;
    }
    if (marital.label === "Select") {
      marital.label = location.state.detail.marital;
    }
    if (dateRef.current.value==="") {
      dateRef.current.value  = location.state.detail.dob;
    }
    if (ansdateRef.current.value==="") {
      ansdateRef.current.value  = location.state.detail.anniversary_date;
    }
    if (businessVerticalSelected.label === "Select") {
      businessVerticalSelected.label = location.state.detail.business_vertical;
    }
    if (!(leadTypeSelected.value === "Leads" || leadTypeSelected.value === "Data")) {
      dispatcher(
        showSnackbarAction(
          "Lead Type Required!!",
          "error"
        )
      );
      return;
    }

    if(leadSourceSelected==="Select"){
      dispatcher(
        showSnackbarAction(
          "Lead source Required!!",
          "error"
        )
      );
      return;
    }
    if(firstNameRef.current.value !== "" && aphabetValidator(firstNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("Accepts only alphabet or alphanumeric combination In Name", "error"));
      return;
  }
  if(lastNameRef.current.value !== "" && aphabetValidator(lastNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("Accepts only alphabet or alphanumeric combination In Name", "error"));
      return;
  }
    if (stateSelected.label === "Select") {
      stateSelected.label = location.state.detail.state;
    }
    // if (notIntSelected.label === "Select" || notIntSelected.label === "") {
    //   notIntSelected.label = location.state.detail.not_int_reason;
    // }
    // if (otherNotIntRef.current.value === "") {
    //   otherNotIntRef.current.value = location.state.detail.other_not_int_reason;
    // }
    // if (lostSelected.label === "Select") {
    //   lostSelected.label = location.state.detail.lost_reason;
    // }
    // if (otherLostRef.current.value === "") {
    //   otherLostRef.current.value = location.state.detail.other_lost_reason;
    // }
    return true;
  };
  const edit = async (e: any) => {
    e.preventDefault();
    const val = handleCheck();
    googleAnalyticsCTAClick("Contact Update Lead Button","Contact Screen",user)
    if (val) {
      setLoad(true);
      // editContact(
      //   location.state.detail.contactId,
      //   firstNameRef.current.value,
      //   lastNameRef.current.value,
      //   numberRef.current.value,
      //   alternateNumberRef.current.value,
      //   stageSelected.label,
      //   projectSelected.label,
      //   budgetSelected.label,
      //   locationSelected.label,
      //   propertyTypeSelected.label,
      //   propertyStageSelected.label,
      //   leadTypeSelected.value === "Select"
      //     ? "Data"
      //     : leadTypeSelected.value,
      //   leadSourceSelected.value,
      //   addSetSelected.label,
      //   campaignSetSelected.label,
      //   // notIntSelected.label,
      //   // otherNotIntRef.current.value,
      //   // lostSelected.label,
      //   // otherLostRef.current.value,
      //   dispatcher,
      //   history,
      //   (data) => setLoad(data),
      //   numberRef.current.value === location.state.detail.contact_no && alternateNumberRef.current.value === location.state.detail.alternate_no
      //     ? false
      //     : true,
      //   location.state.detail.organization_id,
      //   propertySubTypeSelected.value === "Select"
      //     ? ""
      //     : propertySubTypeSelected.value,
      //   countryCode.split(" ")[0],
      //   numberRef.current.value === location.state.detail.contact_no ? false : true,
      //   alternateNumberRef.current.value === location.state.detail.alternate_no ? false : true,
      // );
      const country = country_code.find(
        (el: any) =>
          el.dial_code === countryCode.split(" ")[0]
      );

      editLead(
        location.state.detail.contactId,
        firstNameRef.current.value,
        lastNameRef.current.value,
        numberRef.current.value,
        alternateNumberRef.current.value,
        stageSelected.label,
        projectSelected.label,
        budgetSelected.value,
        locationSelected.label,
        propertyTypeSelected.label,
        propertyStageSelected.label,
        leadTypeSelected.value === "Select"
          ? "Data"
          : leadTypeSelected.value,
        leadSourceSelected.value,
        addSetSelected.label,
        campaignSetSelected.label,
        // notIntSelected.label,
        // otherNotIntRef.current.value,
        // lostSelected.label,
        // otherLostRef.current.value,
        dispatcher,
        history,
        (data) => setLoad(data),
        numberRef.current.value === location.state.detail.contact_no && alternateNumberRef.current.value === location.state.detail.alternate_no
          ? false
          : true,
        location.state.detail.organization_id,
        propertySubTypeSelected.value === "Select"
          ? ""
          : propertySubTypeSelected.value,
        countryCode.split(" ")[0],
        numberRef.current.value === location.state.detail.contact_no ? false : true,
        alternateNumberRef.current.value === location.state.detail.alternate_no ? false : true,
        authToken,
        gender.value,
        marital.value,
        // dateRef.current.value?dateRef.current.value:location.state.detail.dob,
        dateRef.current.value ? moment(dateRef.current.value).toDate() : location.state.detail.dob ? moment(location.state.detail.dob).toDate() : "",
        // moment(dateRef.current.value?dateRef.current.value:location.state.detail.dob).toDate(),
        ansdateRef.current.value ? moment(ansdateRef.current.value).toDate() : location.state.detail.anniversary_date ? moment(location.state.detail.anniversary_date).toDate() : "",
        // moment(ansdateRef.current.value?ansdateRef.current.value:location.state.detail.anniversary_date).toDate(),
        // ansdateRef.current.value?ansdateRef.current.value:location.state.detail.anniversary_date,
        cusAdd,
        businessVerticalSelected.label,
        stateSelected.label,
        user.uid,
        unitRef?.current?.value,
        requirement_Type.value,
        cityRef?.current?.value,
        country ? country.name : "India",
        budgetSelected.label
      );
    }
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  // const selectInputContainerStyles = { width: "140px", marginRight: "5px" };
  const selectInputContainerStyles = {  };
  // console.log("unitRef?.current?.value",unitRef?.current?.value,requirement_Type.value)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent typing 'e', '.', and '-' keys if type is number
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleKeyDownNumber = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent typing 'e', '.', and '-' keys if type is number
    if (e.key === "e" || e.key === "." || e.key === "-") {
      e.preventDefault();
    }
  };
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Edit_Contact_Screen',user)
      }
    }
  },[user])

  return (
    // <div className={styles.parent}>
    //   {load && <Loading />}
    //   <div className={styles.child}>
    //     <div className={styles.headerView}>
    //       <p className={styles.heading}> Edit Contact Details</p>
    //       <AiOutlineClose
    //         className={styles.closeIcon}
    //         size={25}
    //         onClick={() => history.replace("/")}
    //       />
    //     </div>
    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>First Name</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter first name"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={firstNameRef}
    //             value={location.state.detail.customer_name.split(" ")[0]}
    //           >
    //             <FaUser color={"#808080"} />
    //           </TextInput>
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Last Name</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter last name"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={lastNameRef}
    //             value={location.state.detail.customer_name.slice(
    //               location.state.detail.customer_name.split(" ")[0].length
    //             )}
    //           >
    //             <FaUser color={"#808080"} />
    //           </TextInput>
    //         </div>
    //       </div>
    //     </div>
    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Mobile No.</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number"}
    //             style={
    //               userRole !== "Lead Manager"
    //                 ? { backgroundColor: "#f5f5f5" }
    //                 : { backgroundColor: "#fff" }
    //             }
    //             ref={numberRef}
    //             disabled={userRole !== "Lead Manager" ? true : false}
    //             value={location.state.detail.contact_no}
    //           />
    //         </div>
    //       </div>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Alternate No.</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={alternateNumberRef}
    //             value={location.state.detail.alternate_no}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Stage</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={stage}
    //             disable={true}
    //             selectedValue={stageSelected}
    //             setSelectedValue={(value) => {
    //               setStageSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Project</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={projectsList}
    //             selectedValue={projectSelected}
    //             setSelectedValue={(value) => {
    //               setProjectSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Location</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={locationsList}
    //             selectedValue={locationSelected}
    //             setSelectedValue={(value) => {
    //               setlocationSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Budget</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={budgetsList}
    //             selectedValue={budgetSelected}
    //             setSelectedValue={(value) => {
    //               setBudgetSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Property Type</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={propertyTypeList}
    //             selectedValue={propertyTypeSelected}
    //             setSelectedValue={(value) => {
    //               setPropertyTypeSelected(value);
    //             }}
    //           />
    //         </div>
    //         </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Property Stage</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={propertyStageList}
    //             selectedValue={propertyStageSelected}
    //             setSelectedValue={(value) => {
    //               setPropertyStageSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     {/* <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Not Interested Reason</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={notIntReasonList}
    //             selectedValue={notIntSelected}
    //             setSelectedValue={(value) => {
    //               setNotIntSelected(value);
    //             }}
    //             disable={userRole !== "Lead Manager" ? true : false}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Other Not Interested Reason</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Other Reason"}
    //             style={
    //               userRole !== "Lead Manager"
    //                 ? { backgroundColor: "#f5f5f5" }
    //                 : { backgroundColor: "#fff" }
    //             }
    //             ref={otherNotIntRef}
    //             disabled={userRole !== "Lead Manager" ? true : false}
    //             value={location.state.detail.other_not_int_reason}
    //           ></TextInput>
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Lost Reason</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={lostReasonList}
    //             selectedValue={lostSelected}
    //             setSelectedValue={(value) => {
    //               setLostSelected(value);
    //             }}
    //             disable={userRole !== "Lead Manager" ? true : false}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Other Lost Reason</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Other Reason"}
    //             style={
    //               userRole !== "Lead Manager"
    //                 ? { backgroundColor: "#f5f5f5" }
    //                 : { backgroundColor: "#fff" }
    //             }
    //             ref={otherLostRef}
    //             disabled={userRole !== "Lead Manager" ? true : false}
    //             value={location.state.detail.other_lost_reason}
    //           ></TextInput>
    //         </div>
    //       </div>
    //     </div> */}

    //     <div className={styles.box2}>
    //       {userRole === "Lead Manager" && (
    //         <div className={styles.divide}>
    //           <div className={styles.title}>
    //             <p className={styles.one}>Lead Source</p>
    //             <p className={styles.two}></p>
    //           </div>
    //           <div style={{ marginTop: "7px" }}>
    //             <Dropdown
    //               option={leadSourceList}
    //               selectedValue={leadSourceSelected}
    //               setSelectedValue={(value) => {
    //                 setLeadSourceSelected(value);
    //               }}
    //             />
    //           </div>
    //         </div>
    //       )}

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Property Sub Type</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div style={{ marginTop: "7px" }}>
    //           <Dropdown
    //             option={propertySubType}
    //             selectedValue={propertySubTypeSelected}
    //             setSelectedValue={(value) => {
    //               setPropertySubTypeSelected(value);
    //             }}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title} style={{ marginBottom: "3%" }}>
    //           <p className={styles.one}>Country Code</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <Select
    //             options={choice()}
    //             onChange={(data) => {
    //               if (data) {
    //                 setCountryCode(data.label);
    //               }
    //             }}
    //             isSearchable={true}
    //             value={{ label: countryCode, value: countryCode }}
    //           />
    //         </div>
    //       </div>
    //     </div>
    //     <button className={styles.button} onClick={() => edit()}>
    //       Update
    //     </button>
    //   </div>
    // </div>
    <div className={styles.parent} style={containerStyles}>
      {load && <Loading />}
      <div
        // className={styles.headerView}
        className="d-flex flex-row w-100 px-4 pt-4"
      >
        <h5
        // className={styles.heading}
        > Edit Contact Details</h5>
        <AiOutlineClose
          className={styles.closeIcon}
          size={25}
          onClick={() => history.replace("/")}
        />
      </div>
      <div
        // className={styles.child}
        className="w-100 d-flex flex-column gap-2 px-4"
      >
        <form className="card pt-1 pb-4 px-4 shadow rounded mt-2 pt-4" style={cardContainerStyles}>
          <div className={styles.box2}>

          <div className={styles.divide}>
              <Label label="Requirement Type" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={Requirement}
                  selectedValue={requirement_Type}
                  setSelectedValue={(value) => {
                    setRequirement_Type(value);
                    setBudgetSelected({
                      label: "Select",
                      value: "Select",
                    })
                  }}
                />
              </div>  
            </div>
            <div className={styles.divide}>
              <Label label="First Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={firstNameRef}
                  value={location.state.detail.customer_name.split(" ")[0]}
                  validator={aphabetValidator}
                >
                  <FaUser color={"#808080"} />
                </TextInput>
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Last Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={lastNameRef}
                  value={location.state.detail.customer_name.slice(
                    location.state.detail.customer_name.split(" ")[0].length
                  ).trim()}
                  validator={aphabetValidator}
                  onKeyDown={handleKeyDown}
                >
                  <FaUser color={"#808080"} />
                </TextInput>
              </div>
            </div>
            </div>

          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Contact Number" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={
                    (userRole === "Lead Manager" || user.profile === "Admin")
                      ? { backgroundColor: "#fff" }
                      : { backgroundColor: "#f5f5f5"  }
                  }
                  ref={numberRef}
                  disabled={(userRole === "Lead Manager" || user.profile === "Admin") ? false : true}
                  value={location.state.detail.contact_no}
                  type='number'
                  onKeyDown={handleKeyDownNumber}
                  minValue={"0"}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Alternate Number" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={alternateNumberRef}
                  value={location.state.detail.alternate_no}
                  type='number'
                  onKeyDown={handleKeyDownNumber}
                  minValue={"0"}
                />
              </div>
            </div>
            <div className={styles.divide}>
              {/* <div className={styles.title}>
            <p className={styles.one}>Project</p>
            <p className={styles.two}>*</p>
          </div> */}
              <Label label="Project" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={projectsList?.length === 0?apiLocationData:projectsList}
                  selectedValue={projectSelected}
                  setSelectedValue={(value) => {
                    setProjectSelected(value);
                  }}
                  placeholder='Project'
                  isAutoSuggestionDropdown={true}
                  searchString={(value) => {
                    setDropDownClicked("PROJECT")
                    setSearchString(value);
                  }}
                  setApiLocationData={()=>{
                    setApiLocationData([])
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="City" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={cityRef}
                  value={location.state.detail.city}
                />
              </div>
            </div>
            <div className={styles.divide}>
              {/* <div className={styles.title}>
            <p className={styles.one}>Budget</p>
            <p className={styles.two}>*</p>
          </div> */}
              <Label label="Budget" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                {budgetsList.length===0?                
                <DropDownWithDisplayName
                  option={constantBudget}
                  selectedValue={budgetSelected}
                  setSelectedValue={(value) => {
                    setBudgetSelected(value);
                  }}
                />:
                <Dropdown
                option={budgetsList}
                selectedValue={budgetSelected}
                setSelectedValue={(value) => {
                  setBudgetSelected(value);
                }}
              />}
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Country Code" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }}>
                <Select
                  className={styles.select}
                  options={choice()}
                  onChange={(data) => {
                    if (data) {
                      setCountryCode(data.label);
                    }
                  }}
                  isSearchable={true}
                  value={{ label: countryCode, value: countryCode }}
                />
              </div>
            </div>
          </div>

          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Property Stage" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={propertyStageList}
                  selectedValue={propertyStageSelected}
                  setSelectedValue={(value) => {
                    setPropertyStageSelected(value);
                  }}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Property Sub Type" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={propertySubType}
                  selectedValue={propertySubTypeSelected}
                  setSelectedValue={(value) => {
                    setPropertySubTypeSelected(value);
                  }}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Property Type" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={propertyTypeList}
                  selectedValue={propertyTypeSelected}
                  setSelectedValue={(value) => {
                    setPropertyTypeSelected(value);
                    setPropertySubTypeSelected("Select");
                  }}
                />
              </div>
            </div>
          </div>}
          <div className={styles.box2}>
            
            {(userRole === "Lead Manager" || user.profile === "Admin") && (
              <>
              <div className={styles.divide}>
                <Label label="Lead Source" required={true} />
                <div style={{ ...selectInputContainerStyles }}>
                  <Dropdown
                    option={leadSourceList}
                    selectedValue={leadSourceSelected}
                    setSelectedValue={(value) => {
                      setLeadSourceSelected(value);
                    }}
                  />
                </div>
              </div>
              <div className={styles.divide}>
              <Label label="Location" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={locationsList?.length === 0?apiLocationData:locationsList}
                  selectedValue={locationSelected}
                  setSelectedValue={(value) => {
                    setlocationSelected(value);
                  }}
                  placeholder='Location'
                  isAutoSuggestionDropdown={true}
                  searchString={(value) => {
                    setDropDownClicked("LOCATION")
                    setSearchString(value);
                  }}
                  setApiLocationData={()=>{
                    setApiLocationData([])
                  }}
                />
              </div>
            </div>

             <div className={styles.divide}>
                  <Label label="Campaign" required={false} />
                  <div style={{ ...selectInputContainerStyles }}>
                    <Dropdown
                      option={campaign}
                      selectedValue={campaignSetSelected}
                      setSelectedValue={(value) => {
                        setCampaignSelected(value);
                      }}
                    />
                  </div>
                </div>
             </>
            )}
          </div>
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Lead Type" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={leadTypeList}
                  selectedValue={leadTypeSelected}
                  setSelectedValue={(value) => {
                    setLeadTypeSelected(value);
                  }}
                />
              </div>
            </div>
         
            <div className={styles.divide}>
              <Label label="Gender" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={["Male","Female","Other"]}
                  selectedValue={gender}
                  setSelectedValue={(value) => {
                    setGender(value);
                  }}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Marital Status" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={["Married","Un-married"]}
                  selectedValue={marital}
                  setSelectedValue={(value) => {
                    setMarital(value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.box2}>

          <div className={styles.divide}>
              <Label label="Lead State" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={stateList.length===0?mbConstants.states:stateList}
                  selectedValue={stateSelected}
                  setSelectedValue={(value) => {
                    setStateSelected(value);
                  }}
                />
              </div>
            </div>
          <div className={styles.divide}>
              <Label label="D.O.B" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
            <input
              type="date"
              placeholder="Enter Date"
              ref={dateRef}
              // className={styles.dateInput}
            />
              </div>
            </div>
          <div className={styles.divide}>
              <Label label="Anniversary Date" required={false} />
              <div style={{ ...selectInputContainerStyles }}>
            <input
              type="date"
              placeholder="Enter Date"
              ref={ansdateRef}
              // className={styles.dateInput}
            />
              </div>
            </div>
           
          </div>
          <div className={styles.box2}>
            {/* <div className={styles.divide}>
              <Label label="Lead Stage" required={true} />
              <div style={{ ...selectInputContainerStyles }}>
                <Dropdown
                  option={stage}
                  disable={true}
                  selectedValue={stageSelected}
                  setSelectedValue={(value) => {
                    setStageSelected(value);
                  }}
                />
              </div>
            </div> */}
          
            <div className={styles.divide}>
               <Label label="Add Set" required={false} />
               <div style={{ ...selectInputContainerStyles }}>
                 <Dropdown
                   option={addSet}
                   selectedValue={addSetSelected}
                   setSelectedValue={(value) => {
                     setAddSetSelected(value);
                   }}
                 />
               </div>
             </div>
             <div className={styles.divide}>
              <Label label="Unit No." required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={unitRef}
                  value={location.state.detail.unit_no}
                />
              </div>
            </div>
          </div>
          {(organizationData.business_domain && organizationData.business_domain !== "Real Estate")&&(
                      <div className={styles.divide}>
                      <Label label="Business Vertical" required={false} />
                      <div style={{ ...selectInputContainerStyles }}>
                        <Dropdown
                          option={businessVerticalList}
                          selectedValue={businessVerticalSelected}
                          setSelectedValue={(value) => {
                            setBusinessVerticalSelected(value);
                          }}
                        />
                      </div>
                    </div>
          )}
          <div className={styles.box3}>
            <div
              // className={styles.divide}
              style={{ width: "100%" }}
            >
              <Label label="Customer Address" required={false} />
              <div>
                <textarea
                  // style={{
                  //   marginTop: "1rem",
                  // }}
                  className="form-control"
                  rows={2}
                  placeholder={""}
                  // ref={noteRef}
                  onChange={(e) => setCusAdd(e.target.value)}
                  value={cusAdd}
                ></textarea>
              </div>
            </div>
          </div>
          <button
            // className={styles.button}
            style={{ backgroundColor: "#279f9f" }}
            className={styles.button}
            onClick={(e: any) => edit(e)}>
            Update
          </button>
        </form>

      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userRole: state.user.role,
    theme: state.theme.isLightMode,
    user: state.user.data,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    constants:state.constants.data,
    organizationResources:state.organizationResources.data,
    mbConstants:state?.mbConstant?.data
  };
};

export default connect(mapStateToProps)(EditContact);
